import { ChangeDetectionStrategy, Component, computed, inject, LOCALE_ID, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-refrigerator-toggale',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './refrigerator-toggale.html',
    styleUrl: './refrigerator-toggale.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefrigeratorToggale {
  private locale = inject(LOCALE_ID);

  isArabic = computed(() => this.locale.startsWith('ar'));

  value = input.required<boolean>();
  toggle = output<boolean>();

  onChange(event: Event): void {
    const val = (event.target as HTMLInputElement).checked;
    this.toggle.emit(val);
  }
}
